import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSF Fares API
 */
export const wsfFaresApiMeta: ApiMeta = {
  name: "wsf-fares",
  baseUrl: "https://www.wsdot.wa.gov/ferries/api/fares/rest",
};
